import CONFIG from '../Services/CONFIG';

const buildVideoSource = (video) => {
  if (video.url) return video.url;
  if (video.base64) return video.base64;
  if (!video.key) return null;

  const params = new URLSearchParams();
  if (video.expires) params.set('exp', video.expires);
  if (video.signature) params.set('sig', video.signature);
  const query = params.toString();

  return `${CONFIG.SERVER}/videos/${video.key}${query ? `?${query}` : ''}`;
};

export const VideoRender = ({ message }) => {
  const videos =
    message.videos && message.videos.length > 0
      ? message.videos
      : message.url || message.base64File
        ? [
            {
              url: message.url,
              base64: message.base64File,
              fileName: message.fileName,
              extension: message.extension,
            },
          ]
        : [];

  if (videos.length === 0) return null;

  return (
    <>
      {videos.map((video, idx) => {
        const source = buildVideoSource(video);
        if (!source) return null;

        return (
          <div key={idx} className="video-wrapper">
            <video className="video-player" controls preload="metadata" playsInline src={source} />
            {video.fileName && <div className="video-name">{video.fileName}</div>}
          </div>
        );
      })}
    </>
  );
};
